import { useEffect, useState } from "react";
import Dashboard from "../../pages/Dashboard/Dashboard";
import { useLanguage } from "../LanguageProvider/LanguageProvider ";
import { GetLocalStorage, GetLocalStorageParsed } from "../../Utils/Utils";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserVistingTrackingData } from "../../services/api/user";
import {
  monthNames,
  monthNamesHi,
  parseJSONSafe,
} from "./visitorTrackingUtils";
import { Message } from "../message";

const VisitorTracking = () => {
  const { language } = useLanguage();
  const [visitorTrackingList, setVisitorTrackingList] = useState([]);
  const token = GetLocalStorage("userInfo");
  const userDetail = GetLocalStorageParsed("userDetail");
  const navigate = useNavigate();
  const [apiMessage, setApiMessage] = useState({ type: "", message: "" });
  const { state } = useLocation();

  useEffect(() => {
    if (!token) {
      navigate("/");
    } else {
      getUserVisitorTrackingList();
    }
  }, []);

  useEffect(() => {
    if (state && state.message) {
      setApiMessage({ type: "success", message: state.message });
      // Clear the message once it is rendered
      window.history.replaceState({}, document.title);
    }
  }, [state]);

  const getUserVisitorTrackingList = async () => {
    try {
      const list = await getUserVistingTrackingData();
      setVisitorTrackingList(Array.isArray(list?.data) ? list.data : []);
    } catch (err) {
      console.error("Visitor tracking list error", err);
      setVisitorTrackingList([]);
    }
  };

  return (
    <Dashboard
      first={language ? "आगंतुक ट्रैकिंग" : "Visitor Tracking"}
      second={language ? "आगंतुक ट्रैकिंग" : "Visitor Tracking"}
      head={language ? "आगंतुक ट्रैकिंग" : "Visitor Tracking"}
    >
      {apiMessage && (
        <Message
          apiMessage={apiMessage}
          setApiMessage={setApiMessage}
        ></Message>
      )}
      <div className="aod-bottom">
        {/* ---------- Header ---------- */}
        <div className="page_heading d-flex justify-content-between align-items-center">
          <h5>{language ? "आगंतुक ट्रैकिंग" : "Visitor Tracking"}</h5>

          <button
            type="button"
            onClick={() => navigate("/edit-visitor-tracking")}
            style={{
              marginTop: "8px",
              padding: "8px 12px",
              backgroundColor: "#00684a",
              color: "#ffffff",
              fontSize: "0.875rem",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              textAlign: "right",
            }}
          >
            {language ? "नया निर्माण" : "Create New"}
          </button>
        </div>

        {/* ---------- Table ---------- */}
        <div className="col-md-12">
          <div className="reciept-table table-responsive mt-2">
            <table className="table table-bordered transaction_table">
              <thead>
                <tr>
                  <th>{language ? "क्रम संख्या" : "S.No"}</th>
                  <th>{language ? "होटल का नाम" : "Hotel Name"}</th>
                  <th>{language ? "माह" : "Month"}</th>
                  <th>{language ? "वर्ष" : "Year"}</th>

                  <th>{language ? "भारतीय पर्यटक" : "Indian Tourists"}</th>
                  <th>{language ? "भारतीय नाइट्स" : "Indian Nights"}</th>

                  <th>{language ? "विदेशी पर्यटक" : "Foreigner Tourists"}</th>
                  <th>{language ? "विदेशी नाइट्स" : "Foreigner Nights"}</th>

                  <th>{language ? "राज्य विवरण" : "State Details"}</th>
                  <th>{language ? "देश विवरण" : "Country Details"}</th>

                  <th>{language ? "कार्रवाई" : "Action"}</th>
                </tr>
              </thead>

              <tbody>
                {visitorTrackingList.length > 0 ? (
                  visitorTrackingList.map((item, index) => {
                    const indianTable = parseJSONSafe(
                      item?.indian_tourist_details
                    );
                    const foreignerTable = parseJSONSafe(
                      item?.foreigner_tourist_details
                    );

                    return (
                      <tr key={item?.id || index}>
                        <td>{index + 1}</td>

                        <td>{item?.hotel_name || "--"}</td>
                        <td>
                          {language
                            ? monthNamesHi[item?.report_month - 1]
                            : monthNames[item?.report_month - 1] || "--"}
                        </td>
                        <td>{item?.report_year || "--"}</td>

                        <td>{item?.monthy_total_tourists_indian ?? "--"}</td>
                        <td>{item?.monthy_nghts_spent_indian ?? "--"}</td>

                        <td>{item?.monthy_total_tourists_foreigner ?? "--"}</td>
                        <td>{item?.monthy_nghts_spent_foreigner ?? "--"}</td>

                        <td>
                          {indianTable.length > 0
                            ? `${indianTable.length} ${
                                language ? "राज्य" : "States"
                              }`
                            : "--"}
                        </td>

                        <td>
                          {foreignerTable.length > 0
                            ? `${foreignerTable.length} ${
                                language ? "देश" : "Countries"
                              }`
                            : "--"}
                        </td>

                        <td>
                          <button
                            className="btn btn-green-view"
                            onClick={() =>
                              navigate("/edit-visitor-tracking", {
                                state: { rowData: item }, // ✅ FULL DATA PASSED
                              })
                            }
                          >
                            {language ? "संपादन" : "Edit"}
                          </button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="11" className="text-center">
                      {language ? "कोई डेटा उपलब्ध नहीं" : "No data available"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Dashboard>
  );
};

export default VisitorTracking;
